import React, { useEffect, useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import {
  BlackClear,
  EditPencil,
  UpiIcon,
} from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  BLACK_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import CustomDatePicker from "../../../../components/custom_date_picker";
import { connect, useDispatch } from "react-redux";
import AddAccountModal from "../../add_customer/individual/AddAccountModal";
import CustomModal from "../../../../components/customModal/CustomModal";
import UpdateUpiModal from "../../add_customer/individual/UpdateUpiModal";
import AddCustomerForUpiModal from "../../add_customer/individual/AddCustomerForUpiModal";
import UpdateConfirmUpi from "../../add_customer/individual/UpdateConfirmUpi";
import { useSnackbar } from "notistack";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { SUCCESS } from "../../../../resources/constantsManager";
import { removeAllAccountsAction } from "../../../../../data/redux/action/add_customer/addAccountsAction";

const RowContainer = ({ value, title }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <p
        style={{
          fontSize: 12,
          color: BLACK_COLOR,
          padding: 0,
          margin: 0,
          marginRight: 20,
        }}
      >
        {title}
      </p>
      <p
        style={{
          fontSize: 12,
          color: "#494949",
          padding: 0,
          margin: 0,
        }}
      >
        {value}
      </p>
    </div>
  );
};
function UpdateUpiAfterCustomerAdded({
  onClose,
  customerDetails,
  allAccounts,
  onSuccess,
  profileDetails,
}) {
  const { width, height } = ResizeListener();
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [disableAutoClose, setDisableAutoClose] = useState(
    customerDetails.autoClose
  );
  const [closeByDate, setCloseByDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [updateVidModal, setUpdateVidModal] = useState(false);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [confirmUpiModal, setShowConfirmUpiModal] = useState(false);
  const [virtualId, setVirtualId] = useState(
    customerDetails?.paymentDetails[0]["paymentId"]
  );
  const [showAddUpiModal, setShowAddUpiModal] = useState(false);
  const [userUpiDetails, setUserUpiDetails] = useState([]);
  const [editedUpi, setEditedUpi] = useState("");
  const upiCommonBankName = "@yesbankLTD";
  const upiCommonNumber = profileDetails?.accountNumber;
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const onClickUpdateCustomer = () => {
    // if (userUpiDetails.length === 0) {
    //   setShowAddUpiModal(true);
    // } else {

    console.log(
      {
        autoClose: disableAutoClose,
        brandName: profileDetails?.firstName + " " + profileDetails?.lastName,
        closeDate: !disableAutoClose
          ? closeByDate
            ? closeByDate
            : customerDetails?.closeByDate
          : "",
        franchise: "NEOKRED",
        genre: "ONLINE",
        legalName: "Neokred Technologies Private Limited",
        mcc: "6540",
        merchantName:
          customerDetails.firstName + " " + customerDetails.lastName,
        merchantType: "LARGE",
        onboardingType: "Aggregator",
        ownerShipType: "PRIVATE",
        vpa: `${virtualId}${upiCommonBankName}`,
        customerHashId: customerDetails?.customerHashId,
      },
      "ss"
    );

    // setIsLoading(true);
    // ApiRequestPost.updateCustomers({
    //   autoClose: disableAutoClose,
    //   brandName: profileDetails?.firstName + " " + profileDetails?.lastName,
    //   closeDate: customerDetails?.closeByDate,
    //   franchise: "NEOKRED",
    //   genre: "ONLINE",
    //   legalName: "Neokred Technologies Private Limited",
    //   mcc: "6540",
    //   merchantName: customerDetails.firstName + " " + customerDetails.lastName,
    //   merchantType: "LARGE",
    //   onboardingType: "Aggregator",
    //   ownerShipType: "PRIVATE",
    //   vpa: `${virtualId}${upiCommonBankName}`,
    //   customerHashId: customerDetails?.customerHashId,
    // })
    //   .then((res) => {
    //     if (res.status === SUCCESS) {
    //       enqueueSnackbar(res.message, {
    //         variant: "success",
    //       });
    //       onSuccess();
    //       dispatch(removeAllAccountsAction([]));
    //     } else {
    //       enqueueSnackbar(res.message, {
    //         variant: "error",
    //       });
    //     }
    //     setIsLoading(false);
    //   })
    //   .catch((err) => {
    //     enqueueSnackbar(err.message, {
    //       variant: "error",
    //     });
    //     setIsLoading(false);
    //   });
    // }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 400,
        borderRadius: 30,
        minHeight: showAdvancedOptions ? height * 0.55 : height * 0.35,
        height: "100%",
        // alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Add Upi
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          marginTop: 5,
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <img src={UpiIcon} style={{}} />

          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
            }}
          >
            UPI Transfers (Gpay , Phonepay ,etc){" "}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            marginTop: 10,
          }}
        >
          <div
            style={{
              backgroundColor: "#F3F3F6",
              padding: "10px 0px",
              width: "100%",
              marginBottom: 10,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <RowContainer value={virtualId + upiCommonBankName} />

            <img
              src={EditPencil}
              style={{
                cursor: "pointer",
                marginRight: 20,
              }}
              onClick={() => {
                setUpdateVidModal(true);
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          height: 1,
          backgroundColor: "#F3F3F3",
          margin: "15px 0px",
        }}
      ></div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <div>
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              color: BLACK_COLOR,
              fontFamily: "Roboto",
              fontWeight: "500",
            }}
          >
            {showAdvancedOptions
              ? "Hiide Advance Options"
              : "View Advance Options"}
          </p>
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              color: "#888888",
              fontFamily: "Roboto",
            }}
          >
            {!showAdvancedOptions &&
              "Third party Validation, Auto Close, Description ect"}
          </p>
        </div>
        {showAdvancedOptions ? (
          <IoIosArrowUp
            style={{
              color: "dodgerblue",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowAdvancedOptions(false);
            }}
          />
        ) : (
          <IoIosArrowDown
            style={{
              color: "dodgerblue",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowAdvancedOptions(true);
            }}
          />
        )}
      </div>

      {showAdvancedOptions && (
        <div
          style={{
            marginTop: 40,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderTop: "1px solid #F3F3F3",
              borderBottom: "1px solid #F3F3F3",
              padding: "15px 0px",
            }}
          >
            <div>
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  fontSize: 14,
                  color: BLACK_COLOR,
                  fontFamily: "Roboto",
                }}
              >
                Third Party Validation
              </p>
              {allAccounts.length === 0 ? (
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    color: "#888888",
                    fontFamily: "Roboto",
                  }}
                >
                  Not Configured
                </p>
              ) : (
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    color: "#888888",
                    fontFamily: "Roboto",
                  }}
                >
                  {allAccounts.length} account added
                </p>
              )}
            </div>

            <p
              style={{
                color: allAccounts.length === 10 ? "lightgrey" : "dodgerblue",
                cursor: "pointer",
                fontSize: 14,
              }}
              onClick={() => {
                if (allAccounts.length === 10) {
                } else setShowAddAccountModal(true);
              }}
            >
              Configure
            </p>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderTop: "1px solid #F3F3F3",
              borderBottom: "1px solid #F3F3F3",
              padding: "15px 0px",
              pointerEvents: disableAutoClose && "none",
              opacity: disableAutoClose ? 0.5 : 1,
            }}
          >
            <p
              style={{
                padding: 0,
                margin: 0,
                fontSize: 14,
                color: "#888888",
                fontFamily: "Roboto",
              }}
            >
              Close By
            </p>

            <CustomDatePicker
              onChangeDate={(date) => {
                setCloseByDate(date);
              }}
              datePlaceholder="DD-MM-YYYY"
              style={{
                maxWidth: 150,
                backgroundColor: BG_COLOR,
              }}
            />
          </div>

          <div
            style={{
              //   position: "sticky",
              //   bottom: 0,
              backgroundColor: WHITE_COLOR,
              zIndex: 1000,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 5,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  type="checkbox"
                  style={{
                    height: 17,
                    width: 17,
                  }}
                  value={disableAutoClose}
                  onChange={(value) => {
                    setDisableAutoClose(!disableAutoClose);
                  }}
                />

                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    marginLeft: 10,
                    fontWeight: "500",
                    fontFamily: "Roboto",
                  }}
                >
                  Disable Auto Close
                </p>
              </div>
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  fontSize: 14,
                  color: "#888888",
                  fontFamily: "Roboto",
                }}
              >
                You won't be able to receive payments after this
                <br /> specific date
              </p>
            </div>
          </div>
        </div>
      )}
      <CustomButton
        loading={isLoading}
        title="Next"
        styles={{
          backgroundColor: "dodgerblue",
          height: 50,
          width: "100%",
          border: "none",
          marginTop: 20,
          marginBottom: 20,
        }}
        onClick={() => {
          if (!disableAutoClose) {
            if (closeByDate === "")
              enqueueSnackbar("Please select close by date", {
                variant: "error",
              });
            else {
              onClickUpdateCustomer();
            }
          } else {
            onClickUpdateCustomer();

            // console.log("api called");
          }
        }}
      />
      {showAddUpiModal && (
        <CustomModal
          open={showAddUpiModal}
          onClose={() => {
            setShowAddUpiModal(false);
          }}
        >
          <AddCustomerForUpiModal
            onClickSubmit={(data) => {
              setShowAddUpiModal(false);
              setUserUpiDetails(data);
            }}
          />
        </CustomModal>
      )}

      {updateVidModal && (
        <CustomModal
          open={updateVidModal}
          onClose={() => {
            setUpdateVidModal(false);
          }}
        >
          <UpdateUpiModal
            onClose={() => {
              setUpdateVidModal(false);
            }}
            onClickConfirm={(id) => {
              setShowConfirmUpiModal(true);
              setEditedUpi(id);
            }}
          />
        </CustomModal>
      )}
      {setShowConfirmUpiModal && (
        <CustomModal
          open={confirmUpiModal}
          onClose={() => {
            setShowConfirmUpiModal(false);
          }}
        >
          <UpdateConfirmUpi
            onClose={() => {
              setShowConfirmUpiModal(false);
            }}
            onClickYes={(id) => {
              let newId = `${upiCommonNumber}${id}`;
              setVirtualId(newId);
              setUpdateVidModal(false);
              setShowConfirmUpiModal(false);
            }}
            upi={editedUpi}
          />
        </CustomModal>
      )}

      {showAddAccountModal && (
        <CustomModal
          open={showAddAccountModal}
          onClose={() => {
            setShowAddAccountModal(false);
          }}
        >
          <AddAccountModal
            onClose={() => {
              setShowAddAccountModal(false);
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allAccounts: state.addAccountsReducer.accounts,
    profileDetails: state.profileDetailsReducer.details,
  };
};

export default connect(mapStateToProps)(UpdateUpiAfterCustomerAdded);
